module.exports = __webpack_public_path__ + "static/media/3DPPA29.e972ce8f.jpg";